import React, { createContext, useContext, useState } from 'react';

import { Modal, Text, Small } from '@bigcommerce/big-design';

const HelpContext = createContext({
  setHelp: () => {},
  openHelp: () => {},
});

export const useHelp = () => useContext(HelpContext);

export const HelpProvider = ({ children }) => {
  const [helpContent, setHelpContent] = useState(null);
  const [open, setOpen] = useState(false);

  const setHelp = (content) => {
    setHelpContent(content);
  }

  const openHelp = () => {
    setOpen(true);
  }

  return(
    <HelpContext.Provider value={{ setHelp, openHelp }}>
      {children}

      <Modal
        actions={[
          {
            text: 'Close',
            variant: 'subtle',
            onClick: () => setOpen(false),
          },
        ]}
        closeOnClickOutside={true}
        closeOnEscKey={true}
        header={`Help${helpContent?.title ? `: ${helpContent.title}` : ''}`}
        isOpen={open}
        onClose={() => setOpen(false)}
      >
        { helpContent?.description &&
          <>
            {helpContent.description}
            <hr/>
          </>
        }

        { helpContent?.helpLink &&
          <Text>
            <a href={`https://athousandapps.com/${helpContent.helpLink}`} target="_blank" rel="noreferrer">See more details on using this page here.</a>
          </Text>
        }

        <Small>Have questions or need some help? Contact us at <a href="mailto:support@athousandapps.com">support@athousandapps.com</a></Small>
      </Modal>
    </HelpContext.Provider>
  )
}

export default HelpContext;
